exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1pQRUsgMwHuNQYZtxgkHxK{margin-bottom:-var(--studentSeparator)}._1pQRUsgMwHuNQYZtxgkHxK:after{background:#fbfbfb;content:\"\";display:block;height:var(--studentSeparator);margin-top:-var(--studentSeparator);position:relative;width:100%;z-index:1}._177sUIMdGywbZUh-fn3odr{margin-bottom:0}._2Z7BNV5By4igRFYqanByAw{margin:0}._3hZgcCGpjEo_rkxc21PJh3{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;border-bottom:var(--studentSeparator) solid #dedede;cursor:pointer;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;padding:0 .71429rem;white-space:nowrap}._3hZgcCGpjEo_rkxc21PJh3 [data-prop=name]{font-weight:400;text-decoration:underline}._3mLUlHLHcQqnAsfNNYwO-6{margin-left:-.71429rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"StudentPicker": "_1pQRUsgMwHuNQYZtxgkHxK",
	"StudentPicker_grid": "_177sUIMdGywbZUh-fn3odr",
	"StudentPicker_item": "_2Z7BNV5By4igRFYqanByAw",
	"StudentPicker_student": "_3hZgcCGpjEo_rkxc21PJh3",
	"__selected": "_3K3YUY3vDGbiM-MHuoy7rl",
	"StudentPicker_student_profile": "_3mLUlHLHcQqnAsfNNYwO-6"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.2/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/AssignHomework/Assignments/PersonalisedHomeworkFormCard/StudentPicker/style.postcss
// module id = 1726
// module chunks = 0